import { DistributionActionTypes, GeneratePayload } from './distributionTypes';
import { FormatKey, AngleKey } from '../insight/insightTypes';

export const distributionApiResponseSuccess = (actionType: string, data: any) => ({
  type: DistributionActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const distributionApiResponseError = (actionType: string, error: string) => ({
  type: DistributionActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const generateAction = (payload: GeneratePayload) => ({
  type: DistributionActionTypes.GENERATE,
  payload,
});

export const setActiveFormat = (format: FormatKey) => ({
  type: DistributionActionTypes.SET_ACTIVE_FORMAT,
  payload: { format },
});

export const setCopiedFormat = (format: FormatKey | null) => ({
  type: DistributionActionTypes.SET_COPIED,
  payload: { format },
});

export const setFeedback = (format: FormatKey, vote: 'up' | 'down') => ({
  type: DistributionActionTypes.SET_FEEDBACK,
  payload: { format, vote },
});

export const setPackId = (packId: string) => ({
  type: DistributionActionTypes.SET_PACK_ID,
  payload: { packId },
});

export const resetDistribution = () => ({
  type: DistributionActionTypes.RESET,
});
